import {
  GET_LITEYMPJOB,
  LITEYMPJOB_ERROR,
  SHOW_LITEYMPJOB_LOADING,
  GET_LITEYMPJOB_DETAILS,
  CREATE_LITEYMPJOB_SUCCESS,
  SHOW_EDIT_LITEYMPJOB_LOADING,
  EDIT_LITEYMPJOB_SUCCESS,
  DELETE_LITEYMPJOB,
  MIGRATE_LITEYMPJOB_SUCCESS,
  // Modification start - 04.16.2025 - maco-magsael-sc-769
  GET_LITEYMPJOB_TASKS,
  // Modification end - 04.16.2025 - maco-magsael-sc-769
} from '../actions/types';

const initialState = {
  liteympjoblist: [],
  liteympjobID: null,
  liteympjobDetails: null,
  liteympjobLoading: false,
  editLiteympjobLoading: false,
  // Modification start - 04.16.2025 - maco-magsael-sc-769
  liteympjobTasks: null,
  // Modification end - 04.16.2025 - maco-magsael-sc-769
  error: {},
};

/**
 * maco-magsael-sc-677: Created for YMP Lite - Interface for lite equipment and jobs
 * maco-magsael-sc-769: Lite Admin - add pages (files) to upload documents, add job checklist and search boat
 */

// eslint-disable-next-line
export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case SHOW_LITEYMPJOB_LOADING:
      return {
        ...state,
        liteympjobLoading: true,
      };
    case MIGRATE_LITEYMPJOB_SUCCESS:
      return {
        ...state,
        liteympjobLoading: false,
      };
    case SHOW_EDIT_LITEYMPJOB_LOADING:
      return {
        ...state,
        editLiteympjobLoading: true,
      };
    case GET_LITEYMPJOB:
      return {
        ...state,
        liteympjoblist: payload,
        liteympjobLoading: false,
      };
    case EDIT_LITEYMPJOB_SUCCESS:
      return {
        ...state,
        liteympjoblist: state.liteympjoblist.map((job) =>
          job._id === payload._id
            ? {
                ...job,
                title: payload.title,
                equipment: payload.equipment,
                equipmentID: payload.equipmentID,
                description: payload.description,
                repeating: payload.repeating,
                unplanned: payload.unplanned,
                hours: payload.hours,
                days: payload.days,
                department: payload.department,
                date: payload.date,
              }
            : job
        ),
        liteympjobDetails: {
          ...payload,
          title: payload.title,
          equipment: payload.equipment,
          equipmentID: payload.equipmentID,
          description: payload.description,
          repeating: payload.repeating,
          unplanned: payload.unplanned,
          hours: payload.hours,
          days: payload.days,
          department: payload.department,
          date: payload.date,
        },
        editLiteympjobLoading: false,
        liteympjobLoading: false,
      };
    case GET_LITEYMPJOB_DETAILS:
      return {
        ...state,
        liteympjobDetails: payload,
        // Modification start - 04.16.2025 - maco-magsael-sc-769
        liteympjobTasks: {
          jobTasks: payload.jobTasks,
        },
        // Modification end - 04.16.2025 - maco-magsael-sc-769
        liteympjobLoading: false,
      };
    case CREATE_LITEYMPJOB_SUCCESS:
      return {
        ...state,
        liteympjoblist: [payload, ...state.liteympjoblist],
        liteympjobLoading: false,
      };

    // Modification start - 04.16.2025 - maco-magsael-sc-769
    case GET_LITEYMPJOB_TASKS:
      return {
        ...state,
        liteympjobTasks: {
          jobTasks: payload.jobTasks,
        },
        liteympjobLoading: false,
      };
    // Modification end - 04.16.2025 - maco-magsael-sc-769
    case LITEYMPJOB_ERROR:
      return {
        ...state,
        error: payload,
        liteympjobLoading: false,
      };
    case DELETE_LITEYMPJOB:
      return {
        ...state,
        liteympjoblist: state.liteympjoblist.filter(
          (group) => group._id !== payload
        ),
        liteympjobLoading: false,
      };
    default:
      return state;
  }
}
